import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ChevronDown, ChevronRight } from 'lucide-react';

export const Section = ({ title, icon: Icon, children, defaultOpen = false, badge = null }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div className="border rounded-lg overflow-hidden bg-white shadow-sm">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between px-4 py-2.5 hover:bg-gray-50 transition-colors">
        <div className="flex items-center gap-2">
          <div className="h-7 w-7 rounded-md bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center">
            <Icon className="h-4 w-4 text-white" />
          </div>
          <span className="font-semibold text-sm text-gray-900">{title}</span>
          {badge && (<span className="text-xs px-2 py-0.5 rounded-full bg-blue-100 text-blue-700">{badge}</span>)}
        </div>
        {isOpen ? <ChevronDown className="h-4 w-4 text-gray-400" /> : <ChevronRight className="h-4 w-4 text-gray-400" />}
      </button>
      {isOpen && (<div className="px-4 pb-3 pt-1 border-t bg-gray-50/50">{children}</div>)}
    </div>
  );
};

export const EditableField = ({ label, value, onChange, type = 'text', options = [], disabled = false, placeholder = '', className = '' }) => {
  if (type === 'textarea') {
    return (
      <div className={`space-y-1 ${className}`}>
        <Label className="text-xs text-gray-600">{label}</Label>
        <Textarea value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder || `Enter ${label.toLowerCase()}`} className="min-h-[60px] text-sm" disabled={disabled} />
      </div>
    );
  }
  if (type === 'select') {
    return (
      <div className={`space-y-1 ${className}`}>
        <Label className="text-xs text-gray-600">{label}</Label>
        <Select value={value || ''} onValueChange={onChange} disabled={disabled}>
          <SelectTrigger className="h-9"><SelectValue placeholder={placeholder || `Select ${label}`} /></SelectTrigger>
          <SelectContent>{options.map((opt) => (<SelectItem key={opt} value={opt}>{opt}</SelectItem>))}</SelectContent>
        </Select>
      </div>
    );
  }
  if (type === 'number') {
    return (
      <div className={`space-y-1 ${className}`}>
        <Label className="text-xs text-gray-600">{label}</Label>
        <Input type="number" value={value === 0 ? '' : (value || '')} onChange={(e) => onChange(e.target.value === '' ? 0 : parseFloat(e.target.value))} placeholder={placeholder || '0'} className="h-9 text-sm" disabled={disabled} />
      </div>
    );
  }
  return (
    <div className={`space-y-1 ${className}`}>
      <Label className="text-xs text-gray-600">{label}</Label>
      <Input value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder || `Enter ${label.toLowerCase()}`} className="h-9 text-sm" disabled={disabled} />
    </div>
  );
};
